import { type } from 'arktype';
import { createPaginatedResponseSchema } from '../shared/pagination';

/** Contrato del catálogo `badge` (insignia otorgable, ver dominio de reputación). */
export const badgeResponseSchema = type({
	createdAt: 'string.date.iso',
	description: 'string | null',
	id: 'string.uuid',
	imageUrl: 'string | null',
	name: 'string',
	slug: 'string',
}).onUndeclaredKey('delete');

export type BadgeResponse = typeof badgeResponseSchema.infer;

export const createBadgeSchema = type({
	'description?': 'string',
	'imageUrl?': 'string',
	name: 'string',
	slug: 'string',
}).onUndeclaredKey('delete');

export type CreateBadge = typeof createBadgeSchema.infer;

export const updateBadgeSchema = createBadgeSchema.partial();

export type UpdateBadge = typeof updateBadgeSchema.infer;

export const badgePaginatedResponseSchema = createPaginatedResponseSchema(badgeResponseSchema);

export type BadgePaginatedResponse = typeof badgePaginatedResponseSchema.infer;
